// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-bed3932c] .ant-table-thead > tr > th,[data-v-bed3932c] .ant-table-tbody > tr > td {\n  padding-right: 8px;\n  padding-left: 8px;\n}\n", ""]);
// Exports
module.exports = exports;
